import React from 'react';
import { AccountLookUpSelector } from '../../elements/AccountLookUpSelector';
import { AccountWidgetAccountsController } from '@shared/commons/AccountWidget/AccountWidgetAccountsController';
import { LinkedSystem } from '../../../misc/LinkedSystem';
export class AccountLookupContextMenuItem extends React.Component {
    constructor(props) {
        super(props);
        this.onSelectAccount = (account) => {
            if (isNullOrUndefined(account)) {
                return;
            }
            this.setState({ selectedAccount: account });
            AccountWidgetAccountsController.Account = account;
            if (LinkedSystem.accLinkingActive) {
                LinkedSystem.accLinkingOn(AccountWidgetAccountsController.Account.AcctNumber);
            }
        };
        this.state = {
            selectedAccount: props.item.value
        };
    }
    render() {
        const activeStyle = this.props.item.selected ? ' _active' : '';
        const disabledStyle = this.props.item.enabled === false ? ' _disabled' : '';
        return (React.createElement("div", { className: `new-context-menu-row${activeStyle}${disabledStyle} no-hover` },
            React.createElement("div", { className: "new-context-menu-item" },
                React.createElement(AccountLookUpSelector, { ignoreForceLinkingByAccount: true, selectedItem: this.state.selectedAccount, onSelectItem: this.onSelectAccount, onDropDownFormOpened: () => {
                        this.props.onCloseContextMenu();
                    } }))));
    }
}
